module.exports = __webpack_public_path__ + "img/laptop.19092694.jpg";